import React from 'react';

const ResultBackground = () => {
    return (
        <>

            <svg xmlns="http://www.w3.org/2000/svg" width="493" height="980" viewBox="0 0 493 980">
                <g><circle cx="211.5" cy="768.5" r="211.5" fill="#00aa96"/></g>
                <g><circle cx="470.5" cy="387.5" r="22.5" fill="#1c2284"/></g>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="678" height="739" viewBox="0 0 678 739">
                <g><circle cx="446.5" cy="32.5" r="32.5" fill="#0096d7"/></g>
                <g>
                    <circle cx="446" cy="396" r="232" fill="#00aa96"/>
                    <circle cx="446" cy="396" r="162" fill="#1c2284"/>
                </g>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="678" height="739" viewBox="0 0 678 739">
                <g><circle cx="44.5" cy="694.5" r="44.5" fill="#e62d82"/></g>
            </svg>
        </>
    );
}

export default ResultBackground;
